__turbopack_context__.v({
  "promo": "Promo-module-scss-module__Ml3zOW__promo",
  "promoSectionHeaderHeader": "Promo-module-scss-module__Ml3zOW__promoSectionHeaderHeader",
  "promoText": "Promo-module-scss-module__Ml3zOW__promoText",
  "promoTextCta": "Promo-module-scss-module__Ml3zOW__promoTextCta",
  "sectionHeaderPromo": "Promo-module-scss-module__Ml3zOW__sectionHeaderPromo",
});
